import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";
import {IAttributes, IAugmentedJQuery, IDirective, IScope} from "angular";
import {TransitionService} from "@uirouter/angularjs";
import {KlientinformasjonFraUserAgent} from "felles/tjenester/KlientinformasjonFraUserAgent";
import {erLikIgnorerCasing} from "felles/stoettefunk/strenger";

const css = require('./appBanner.scss');
export function appBannerForInjisering() {
        return [
            regNavn.ng.ui.$transitions,
            Konfigurasjon.regNavn,
            KlientinformasjonFraUserAgent.regNavn,
            appBanner
        ]
    }

    /**
     * Direktiv som viser app banner med lenke for installasjon av app.
     */
    export function appBanner($transitions: TransitionService,
                              konfigurasjon: Konfigurasjon,
                              klientinformasjon: KlientinformasjonFraUserAgent): IDirective {
        return {
            restrict: 'E',
            replace: true,
            template: require('./appBanner.html'),
            link: ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes) => {
                const erAndroid = erLikIgnorerCasing(klientinformasjon.kallendeklientinformasjon().osNavn, 'android');
                const erIos = erLikIgnorerCasing(klientinformasjon.kallendeklientinformasjon().osNavn, 'ios');

                // vent på at angular har gjort sitt før vi legger til meta.
                const vedNavigasjon = $transitions.onSuccess({}, trans => {
                    const data:any = trans.to().data;
                    if (!data) {
                        // Ingen data definert på view.
                        deaktiver();
                        return;
                    }

                    if (data.visAppBanner) aktiver();
                    else if (!data.visAppleStoreBanner) deaktiver();
                });
                $scope.$on('$destroy', e => vedNavigasjon());

                function aktiver() {
                    if (erIos) aktiverForIos();
                    else if (erAndroid) aktiverForAndroid();
                }

                function deaktiver() {
                    if (erIos) deaktiverForIos();
                    else if (erAndroid) deaktiverForAndroid();
                }


                //android relatert
                let androidAppBadgeAktivert = false;
                let skjulAndroidAppBadge = false;

                function aktiverForAndroid() {
                    androidAppBadgeAktivert = true;
                }

                function deaktiverForAndroid() {
                    androidAppBadgeAktivert = false;
                }

                $scope['visAndroidAppBadge'] = ()=> {
                    return androidAppBadgeAktivert && !skjulAndroidAppBadge;
                };

                $scope['skjulAndroidAppBadge'] = ()=> {
                    skjulAndroidAppBadge = true;
                };

                //ios relatert
                function aktiverForIos() {
                    if ($element.parents("html").find('head meta[name="apple-itunes-app"]').length !== 0)
                        return;
                    $element.parents("html").find('head').append(`<meta name="apple-itunes-app" content="app-id=${konfigurasjon.apple_itunes_app_id}">`);
                }

                function deaktiverForIos() {
                    $element.parents("html").find('head meta[name="apple-itunes-app"]').remove();
                }

            }
        }
    }

